
export var mediasPageSchema = [
    {
      name: 'Medias',
    },
  ]
